import { render, staticRenderFns } from "./adminNav.vue?vue&type=template&id=c8fcf52c&scoped=true&"
import script from "./adminNav.vue?vue&type=script&lang=js&"
export * from "./adminNav.vue?vue&type=script&lang=js&"
import style0 from "./adminNav.vue?vue&type=style&index=0&id=c8fcf52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fcf52c",
  null
  
)

export default component.exports